import {
    AuditOutlined,
    BankOutlined,
    ContainerOutlined,
    DollarOutlined,
    FilePdfOutlined,
    HomeOutlined,
    ReconciliationOutlined,
    UserOutlined,
    WarningOutlined,
} from "@ant-design/icons";

export const ICONS: { [key: string]: JSX.Element } = {
    '/home': <HomeOutlined />,
    '/produccion': <ContainerOutlined />,
    '/cotizador': <ReconciliationOutlined />,
    '/emision': <AuditOutlined />,
    '/cuenta-corriente': <BankOutlined />,
    '/siniestros': <WarningOutlined />,
    '/cobranzas': <DollarOutlined />,
    '/poliza-electronica': <FilePdfOutlined />
}

export const getMenuIcon = ( menuDescription: string ): JSX.Element => {
    if( menuDescription in ICONS ) return ICONS[ menuDescription ];
    return <UserOutlined />
}